<div id="dv-tab-prof-1" class="container-filter-cards">
  <div id="dv-tab-prof-2" class="container-breadcrumb">
    <p id="id-breadcrumb-3" class="copec-lg-14 bread-3">Admin / Reporte Solicitudes Usuarios /</p>
  </div>
  <br>





  <div class="container-filtros-superiores">
    <div class="filtro-fecha">
      <span class="lowTitle1">Fecha de inicio</span>
      <mat-form-field>
        <mat-label>Día - Mes - Año</mat-label>
        <input matInput [matDatepicker]="fecha_inicio" [(ngModel)]="selectedStartDate" name="fecha-inicio" />
        <mat-datepicker-toggle matIconSuffix [for]="fecha_inicio">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #fecha_inicio></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="filtro-fecha">
      <span class="lowTitle1">Fecha de término</span>
      <mat-form-field>
        <mat-label>Día - Mes - Año</mat-label>
        <input matInput [matDatepicker]="fecha_termino" [(ngModel)]="selectedEndDate" name="fecha-termino" />
        <mat-datepicker-toggle matIconSuffix [for]="fecha_termino">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #fecha_termino></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="container-filtros-inferiores">
    <div class="filtro-texto-completo">
      <span class="lowTitle1">Criterio de búsqueda</span>
      <mat-form-field>
        <mat-label>ID Solicitud, Nombre, Apellido, Email, Estado Solicitud</mat-label>
        <input matInput [(ngModel)]="criterio_busqueda" name="filtro-texto" />
      </mat-form-field>
    </div>
  </div>

  <div class="container-buttons">
    <button class="button-rounded" (click)="buscar_solicitudes()">
      Buscar
    </button>
    <button class="button-excel" *ngIf="!isLoadedReport" (click)="descargar_reporte_detalle_solicitudes_usuarios()">
      <i class="fa-solid fa-file-excel"></i>
      Descargar Todo (sin filtros)
    </button>
    <button class="button-excel" *ngIf="isLoadedReport" [disabled]="isLoadedReport">
      <i class="fa-solid fa-file-excel"></i>
      Generando reporte ....
    </button>
  </div>

  <div id="dv-tab-prof-10">
    <div *ngIf="isLoaded">
      Cargando datos ....
    </div>
    <table *ngIf="!isLoaded" mat-table [dataSource]="rpt_detalle_solicitudes_usuarios" matSort
      (matSortChange)="announceSortChange($event)" class="table-responsive mat-elevation-z8"
      aria-label="Solicitudes realizadas por usuarios">
      <ng-container matColumnDef="rut">
        <th class="th-header" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name"
          class="display-none">
          Rut
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.rut }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nombre_completo">
        <th class="th-header" mat-header-cell *matHeaderCellDef class="display-none">
          Nombre Completo
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.nombre_completo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Email">
        <th class="th-header" mat-header-cell *matHeaderCellDef class="display-none">
          Email
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.Email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="plan_activo" removeRowDef>
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Plan Activo
        </th>
        <td mat-cell *matCellDef="let element" remove class="display-none" RowDef>
          {{ element.plan_activo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="beneficio_solicitado">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Beneficio Solicitado
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.beneficio_solicitado }}
        </td>
      </ng-container>

      <ng-container matColumnDef="monto_solicitado">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Monto Solicitado
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.monto_solicitado }}
        </td>
      </ng-container>

      <ng-container matColumnDef="monto_maximo_beneficio">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Monto Máximo Beneficio
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.monto_maximo_beneficio}}
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha_solicitud">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Fecha Solicitud
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{element.fecha_solicitud}}
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha_aprobacion">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Fecha Aprobación
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{element.fecha_aprobacion}}
        </td>
      </ng-container>

      <ng-container matColumnDef="cuotas">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Cuotas
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.cuotas}}
        </td>
      </ng-container>

      <ng-container matColumnDef="estado_nombre">
        <th mat-header-cell *matHeaderCellDef class="display-none">
          Estado Solicitud
        </th>
        <td mat-cell *matCellDef="let element" class="display-none">
          {{ element.estado_nombre}}
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="display-none">Acciones</th>
        <td mat-cell *matCellDef="let element" class="display-none">
          <div class="acciones-buttons-container" [ngClass]="{'solo-archivo': !element.mostrarAnular}">
            <button (click)="abrirPopup(element)"
                    class="button-archivo"
                    [ngClass]="{'completo': !element.mostrarAnular}">
              Detalle
            </button>
            <button *ngIf="element.beneficio_solicitado === 'Cambio de Plan' && element.estado_nombre === 'Aprobada'"
                    (click)="abrir_popup_confirmacion(element.solicitud_id)"
                    mat-icon-button
                    class="button-anular">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsGrid"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">
          No se encontraron resultados para: {{ this.criterio_busqueda === undefined ? 'Sin criterio de búsqueda' :
          this.criterio_busqueda }}
        </td>
      </tr>
    </table>
  </div>

  <div *ngIf="!isLoaded" id="dv-tab-prof-11">
    <app-paginator [currentPage]="currentPage" [totalPages]="totalPages"
      (pageChange)="onPageChange($event)"></app-paginator>
  </div>
</div>

<!-- MODAL DE CONFIRMACIÓN DE ANULACIÓN -->
<div id="popup-confirmacion-anulacion" class="popup-confirmacion" [class.show]="popupConfirmAnularVisible">
  <div class="popup-content-s">

    <!-- HEADER -->
    <div class="popup-header">
      Solicitud de anulación
    </div>
    <!-- BODY -->
    <div class="popup-body">
      <h3 style="text-align: center;">¿Está seguro que desea anular esta solicitud?</h3>
    </div>
    
    <!-- FOOTER CON BOTONES -->
    <div class="popup-footer popup-footer-center">
      <button (click)="confirmar_anulacion()" class="button-confirmar">Sí, Anular</button>
      <button (click)="cerrar_anulacion()" class="button-cancelar">Cancelar</button>
    </div>

  </div>
</div>

<!-- MODAL DE ARCHIVOS -->
<div id="popup-archivos" class="popup-archivos" [class.show]="popupVisible">
  <div class="popup-content">

    <!-- HEADER -->
    <div class="popup-header">
      <h3>Detalle Solicitud</h3>
    </div>

    <!-- MODAL DE CONFIRMACIÓN DE ANULACIÓN -->
    <div id="popup-confirmacion-anulacion" class="popup-confirmacion" [class.show]="popupConfirmAnularVisible">
      <div class="popup-content">

        <!-- HEADER -->
        <div class="popup-header">
          <h2 style="text-align: center;">¿Está seguro que desea anular esta solicitud?</h2>
        </div>

        <!-- FOOTER CON BOTONES -->
        <div class="popup-footer popup-footer-center">
          <button (click)="confirmar_anulacion()" class="button-confirmar">Sí, Anular</button>
          <button (click)="cerrar_anulacion()" class="button-cancelar">Cancelar</button>
        </div>

      </div>
    </div>

    <!-- BODY -->
    <div class="popup-body">
      <h4>Archivos:</h4>
      <table aria-label="Listado de archivos de la solicitud" id="detalle_solicitudes_usuarios"
        *ngIf="archivos.length > 0; else sinArchivos" class="tabla-archivos">
        <thead>
          <tr>
            <th class="th-nombre">Nombre archivo</th>
            <th class="th-accion">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let archivo of archivos">
            <td class="nombre-archivo">{{ archivo }}</td>
            <td class="descarga-archivo">
              <img src="../assets/icon-summary/download.svg" alt="Descargar" class="icono-descarga"
                (click)="descargar_archivo(archivo)" />
            </td>
          </tr>
        </tbody>
      </table>
      <br><br>
      <h4>Aprobaciones:</h4>
      <table aria-label="Listado de archivos de la solicitud" id="detalle_solicitudes_usuarios" class="tabla-archivos" *ngIf="primer_aprobador !== ''; else sinAprobadores">
        <thead>
          <tr>
            <th class="th-nombre">Usuario</th>
            <th class="th-accion">Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="nombre-archivo">
              {{ primer_aprobador }}
            </td>
            <td class="descarga-archivo">
              {{ fecha_primera_aprobacion }}
            </td>
          </tr>
          <tr>
            <td class="nombre-archivo">
              {{ segundo_aprobador }}
            </td>
            <td >
              {{ fecha_segunda_aprobacion }}
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #sinArchivos>
        <p>No hay archivos para esta solicitud.</p>
      </ng-template>
      <ng-template #sinAprobadores>
        <p>No hay aprobaciones para esta solicitud.</p>
      </ng-template>
    </div>

    <!-- FOOTER -->
    <div class="popup-footer">
      <button (click)="cerrarPopup()" class="button-cerrar">Cerrar</button>
    </div>

  </div>
</div>